import React, { Children } from 'react';
import classNames from 'classnames/bind';

import styles from '../../styles.pcss';
const cx = classNames.bind(styles);

export const ServiceGridItem = ({ children }) => Children.map(children, (child, rowIndex) => (
  <div key={+rowIndex} className={cx('component')}>
    {child}
  </div>
));

ServiceGridItem.Wrapper = ({ children }) => children;
